import { Data } from '@react-google-maps/api';
import { ApiBase } from '../api.js';
import {
	SellerStatusListingCounts,
	Sellers,
	SellersDetailParameters,
	SellersParameters
} from '../types/api/sellers.js';

export class ApiSellers extends ApiBase {
	async create(data: unknown): Promise<unknown> {
		const result = await this.api.post('/providers/create', data);
		return result.data;
	}

	async read(data: SellersParameters): Promise<Sellers> {
		const result = await this.api.get('/providers', {
			params: {
				...data
			}
		});
		return result.data;
	}
	async export(data: SellersParameters): Promise<Sellers> {
		const result = await this.api.post('/providers/export', data);
		return result.data;
	}
	async sellerDetail(data: SellersDetailParameters): Promise<Sellers> {
		const { id } = data;
		const result = await this.api.get(`/providers/${id}/detail`, {});
		return result.data;
	}

	async update(data: unknown): Promise<unknown> {
		const result = await this.api.post('/providers/update-provider', data);
		return result.data;
	}

	async delete(data: {id: string, type: string}): Promise<unknown> {
		const result = await this.api.delete(`/providers/${data.id}`, {
			params: {
				type: data.type,
			}
		});
		return result.data;
	}
	async deleteBrandProvider(data: { brand_id: string; provider_id: string }): Promise<unknown> {
		const result = await this.api.delete('/providers/brand-provider', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async updateProviderStatus(data: unknown): Promise<unknown> {
		const result = await this.api.post('/providers/update-provider-status', data);
		return result.data;
	}
	async readBrandSeller(data: SellersParameters): Promise<Sellers> {
		const result = await this.api.get('/providers/brands-provider-list', {
			params: {
				...data
			}
		});
		return result.data;
	}
	async updateStatus(data: unknown): Promise<unknown> {
		const result = await this.api.post('/providers/update-status', data);
		return result.data;
	}

	async getSellerStatusListingCounts(
		provider_id: number | string
	): Promise<SellerStatusListingCounts> {
		const result = await this.api.get(
			`/providers/get-seller-status-listing-counts/provider-id/${provider_id}}`
		);
		return result.data as SellerStatusListingCounts;
	}

	async getSellerByMarketplace(marketplace_id: string): Promise<unknown> {
		const result = await this.api.get(`/providers/get-seller-by-marketplace/${marketplace_id}`);
		return result.data;
	}

	async getSellerById(id: string, brand_id?: string, listing_details?: boolean): Promise<unknown> {
		try {
			const result = await this.api.get(`/providers/${id}`, {
				params: {
					...(brand_id && { brand_id }), // Include brand_id if provided
					...(listing_details !== undefined && { listing_details }) // Include listing_details if defined
				}
			});
			return result.data;
		} catch (error) {
			console.error('Error fetching seller by ID:', error);
			throw error; // Rethrow error for the caller to handle
		}
	}
}
